var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConfirm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "800px",
    height: "800px",
    viewBox: "0 0 32 32",
    enableBackground: "new 0 0 32 32",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Approved"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Approved_1_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.629,21.73c0.192,0.18,0.438,0.27,0.683,0.27s0.491-0.09,0.683-0.27l10.688-10c0.403-0.377,0.424-1.01,0.047-1.413    c-0.377-0.404-1.01-0.425-1.413-0.047l-10.004,9.36l-4.629-4.332c-0.402-0.377-1.035-0.356-1.413,0.047    c-0.377,0.403-0.356,1.036,0.047,1.413L12.629,21.73z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "File_Approve"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Folder_Approved"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Security_Approved"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Certificate_Approved"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "User_Approved"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "ID_Card_Approved"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Android_Approved"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Privacy_Approved"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Approved_2_"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Message_Approved"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Upload_Approved"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Download_Approved"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Email_Approved"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "Data_Approved"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirm);
export default __webpack_public_path__ + "static/media/confirm.036910758f08018796ba035d67d13b8a.svg";
export { ForwardRef as ReactComponent };